import { compact, isEmpty, map, some } from 'lodash-es'
import { Component, Vue } from 'vue-property-decorator'
import { ACTIVATION_POPUP, ACTIVATION_POPUP_PAID } from '~/plugins/feature-flags/flags'
import { ACTIVATION_POPUP_PAID_CONTROL } from '~/plugins/feature-flags/variants'
import { Store } from '~/types/store'

const ACTIVATION_EXPERIMENT_START = new Date('2023-10-24T10:00:00+02:00')

@Component
export default class ActivationConditions extends Vue {
  activationIsDetailsLoading = false

  get activationFeatureName() {
    return this.$accessor.account.isFreemium
      ? ACTIVATION_POPUP
      : ACTIVATION_POPUP_PAID
  }

  activationGetFeatureVariant() {
    return this.$featureFlags?.getVariant?.(this.activationFeatureName)
  }

  activationGetFeatureAllowed() {
    return {
      [ACTIVATION_POPUP]: this.$featureFlags?.isEnabled?.(ACTIVATION_POPUP),
      [ACTIVATION_POPUP_PAID]: this.activationGetFeatureVariant()?.name !== ACTIVATION_POPUP_PAID_CONTROL
    }[this.activationFeatureName]
  }

  activationGetScholarships() {
    try {
      const { value } = this.activationGetFeatureVariant()?.payload ?? {}
      const ids = value ? JSON.parse(value) : value
      return compact(map(
        ids,
        id => this.$accessor.cardList.scholarshipList[id]
      ))
    } catch (err) {
      this.$sentry.captureException(err)
    }
  }

  activationGetVisibilityConditions() {
    const isAllowedVariant = this.activationGetFeatureAllowed()
    const allowedTabs: Store.TabName[] = this.$accessor.account.isFreemium
      ? ['matches']
      : ['recommended', 'easy', 'matches']
    const isOldUser = new Date(this.$auth.user.createdAt) < ACTIVATION_EXPERIMENT_START
    const isActivationPopupSeen = this.$cookies.get('activation-popup-seen')
    const isOnAllowedTab = allowedTabs.includes(this.$store.state.route.params.tabName) || this.$route.name === 'scholarships-recommended'
    const scholarships = compact(this.activationGetScholarships())
    const hasScholarshipsToShow = some(
      scholarships,
      scholarship => !isEmpty(scholarship)
    )
    return {
      isAllowedVariant,
      isNotOldUser: !isOldUser,
      isNotActivationPopupSeen: !isActivationPopupSeen,
      isOnAllowedTab,
      hasScholarshipsToShow
    }
  }
}
